import createHistory from 'history/createBrowserHistory';

export default createHistory({
  basename: process.env.ROUTER_BASE_PATH
});



// WEBPACK FOOTER //
// ./src/historys.js